import { createFileRoute } from "@tanstack/react-router";
import { PosFigmaLP } from "@/components/posfigma/PosFigmaLP";
import { A } from "@/components/orto/assets";

const TITLE = "Pós em Fisioterapia em Ortopedia e Traumatologia | Versão A | FEO";
const DESC =
  "Versão A da LP: pós-graduação 100% online em Ortopedia e Traumatologia. 14 módulos, 360h, reconhecida pelo MEC. Tome decisões clínicas com mais segurança.";
const URL = "https://fisioemortopedia.com.br/orto1";

export const Route = createFileRoute("/orto1")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:url", content: URL },
      { property: "og:type", content: "website" },
      { name: "robots", content: "noindex" }, // LP B em teste — sai do índice até virar A
    ],
    links: [{ rel: "canonical", href: URL }],
  }),
  component: OrtoLP1,
});

function OrtoLP1() {
  return (
    <PosFigmaLP
      product="orto"
      heroBadge="Pós-Graduação 100% online"
      heroTitle={["Fisioterapia", "em Ortopedia", "e Traumatologia"]}
      heroSubtitle="Aprenda a tomar decisões clínicas seguras e seja o(a) fisio que passa confiança no primeiro atendimento."
      coordenadorNome="Leandro Fukusawa"
      coordenadorFoto={A.coordenador}
      coordenadorBio="Coordenador da pós em Ortopedia e Traumatologia da FEO. Especialista em fisioterapia musculoesquelética com mais de 15 anos de prática clínica e ensino, com produção científica indexada e atuação em formação de fisioterapeutas em todo o Brasil."
      ementaSubtitle="Baixe o PDF com a grade completa dos 14 módulos, a lista de professores e o cronograma de aulas da pós em Ortopedia."
      whatsappUrl="https://nimble.li/o9yokpkm"
      whatsappLabel="Falar com o time no WhatsApp"
    />
  );
}
